import React, { useEffect } from "react"
// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"

import { usePagination } from "hooks/usePagination"
import { getNotifications } from "api/admins"
import { useRecoilState } from "recoil"
import notificationState from "atom/notification"
import { myAxios } from "api/axios"
import { useLogout } from "hooks/useLogout"
import unreadState from "atom/unread"

const Layout = props => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // notifications

  const { response, success, error } = usePagination(getNotifications)

  const [notification, setNotification] = useRecoilState(notificationState)
  const [unread, setUnread] = useRecoilState(unreadState)

  useEffect(() => {
    if (response) {
      if (response.data) {
        if (response.data.notifications) {
          setNotification(response.data.notifications)
          setUnread(response.data.unreadCount)
        }
      }
    }
  }, [response])

  const { setLogout } = useLogout()

  myAxios.interceptors.request.use(config => {
    config.headers["Authorization"] = localStorage.getItem("token")
    return config
  })

  myAxios.interceptors.response.use(
    response => {
      return response
    },
    err => {
      if (err.response?.status === 401) {
        setLogout(true)
        document.location.reload()
      } else {
        throw err
      }
    }
  )

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header />
        <Sidebar isMobile={isMobile} />
        <div className="main-content" style={{ paddingTop: "25px" }}>
          {props.children}
        </div>
        <Footer />
      </div>
    </React.Fragment>
  )
}

export default Layout
